import { ErrorHandler, Injectable, inject } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService extends ErrorHandler {
  private monitoringService = inject(MonitoringService);


  override handleError(error: Error) {
    console.error(error);
    this.monitoringService.logException(error);
  }
}
